"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPropertiesSelector = void 0;
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const reselect_1 = require("reselect");
const createDeepEqualSelector = (0, reselect_1.createSelectorCreator)(reselect_1.lruMemoize, isEqual_1.default);
function createPropertiesSelector(selector, ...properties) {
    return createDeepEqualSelector(selector, state => {
        return properties.reduce((acc, prop) => {
            acc[prop] = state ? state[prop] : undefined;
            return acc;
        }, {});
    });
}
exports.createPropertiesSelector = createPropertiesSelector;
